// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"510d0cf8","383":"8d2a3e12","643":"f60ed78d"}[chunkId] + ".chunk.css";
};